
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prettify",
      function () {
        return require("private-next-pages/prettify.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prettify"])
      });
    }
  